import { useInfiniteQuery } from "@tanstack/react-query";
import adaptAdminForms from "src/adapters/adaptAdminForms/adaptAdminForms";
import cmsClient from "src/services/cmsClient";

const select = adaptAdminForms;

const getNextPageParam = ({
	next
}: CMSPaginatedData<IAdminObservationForm>) => {
	return next;
};

const fetchAdminPublishedForms = async (
	nextPageUrl?: string,
	category?: string
) => {
	const url = nextPageUrl || "/observations/admin/forms/";

	const response = await cmsClient.get<CMSPaginatedData<IAdminObservationForm>>(
		url,
		{
			params: {
				category_name: category,
				published: true,
				archived: false
			}
		}
	);
	return response.data;
};

interface Options {
	enabled?: boolean;
	category?: string;
}

const useAdminPublishedFormsQuery = (options: Options = { enabled: true }) => {
	const { enabled, category } = options;

	const query = useInfiniteQuery(
		["adminPublishedForms", category],
		({ pageParam }) => fetchAdminPublishedForms(pageParam, category),
		{
			enabled,
			getNextPageParam,
			select
		}
	);

	return query;
};

export default useAdminPublishedFormsQuery;
